import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const AUDIT_TRAIL_API = `${API_URL}/ledger`
export const AUDIT_TRAIL_FILTER_OPTIONS_API = `${API_URL}/ledger/filters`

export const service = {
  getAuditTrail: (params: ParamsModel) => {
    return axios.get(AUDIT_TRAIL_API, {params})
  },
  getAuditTrailFilterOptions: () => {
    return axios.get(AUDIT_TRAIL_FILTER_OPTIONS_API)
  },
}
